"use client";

import { useEffect } from "react";

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

function shouldReloadForChunkError(error: Error | null | undefined): boolean {
  const msg = String(error?.message || "").toLowerCase();
  return (
    msg.includes("chunkloaderror") ||
    msg.includes("loading chunk") ||
    msg.includes("failed to fetch dynamically imported module") ||
    (msg.includes("mime type") && msg.includes("script"))
  );
}

export default function Error({ error, reset }: Props) {
  useEffect(() => {
    if (!shouldReloadForChunkError(error)) return;
    const t = window.setTimeout(() => window.location.reload(), 300);
    return () => window.clearTimeout(t);
  }, [error]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="w-full max-w-lg rounded-2xl border border-slate-700 bg-slate-900 p-6 text-right">
        <h2 className="text-lg font-bold text-slate-100">اختلال موقت در بارگذاری صفحه</h2>
        <p className="mt-2 text-sm text-slate-300">
          صفحه به‌درستی بارگذاری نشد. یک بار دوباره تلاش کنید.
        </p>
        <div className="mt-4 flex gap-2 justify-end">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-lg bg-cyan-600 px-4 py-2 text-sm font-semibold text-white hover:bg-cyan-500"
          >
            بارگذاری مجدد
          </button>
          <button
            type="button"
            onClick={reset}
            className="rounded-lg border border-slate-600 px-4 py-2 text-sm font-semibold text-slate-200 hover:bg-slate-800"
          >
            تلاش دوباره
          </button>
        </div>
      </div>
    </div>
  );
}

